import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {NzNotificationService} from 'ng-zorro-antd/notification';

export class ValidationError extends Error {
}

export const lookupErrorMessage = (error: any): string => {
  if (typeof error === 'string') {
    return error;
  }
  if (typeof error !== 'object') {
    return JSON.stringify(error);
  }
  if (!!error.error) {
    return lookupErrorMessage(error.error);
  }
  if (!!error.sqlerrm) {
    return lookupErrorMessage(error.sqlerrm);
  }
  return JSON.stringify(error);
};

@Injectable()
export class AppErrorHandler implements ErrorHandler {

  private readonly notifier: NzNotificationService;

  constructor(injector: Injector) {
    this.notifier = injector.get(NzNotificationService);
  }

  handleError(rawError: any) {
    if (rawError === null) {
      return;
    }
    let message: string;
    let title: string;
    const error = rawError.hasOwnProperty('rejection') ? rawError.rejection : rawError;
    if (error?.extensions && error?.message) {
      title = 'GraphQL Error';
      message = error.message;
    } else if (error instanceof HttpErrorResponse) {
      title = error.statusText;
      message = lookupErrorMessage(error);
    } else if (error instanceof ValidationError) {
      title = 'Validation Error';
      message = error.message;
    } else if (error instanceof Error) {
      title = 'Unexpected Error';
      console.log(error);
      message = error.message;
    }
    this.notifier.error(title, message, {nzDuration: 30000});
    throw null; // a trick to prevent infinity loop when pipe error
  }

}
